import { isTelemetryEnabled } from '@/services/systemConfiguration.utilities';
import type { TrackInformation } from '@/track/track.types';

export abstract class TrackerService {
  protected constructor() {}

  abstract trackEvent(category: string, action: string, information: TrackInformation, uniqueEventId: number): void;

  shouldTrack() {
    return isTelemetryEnabled();
  }

  abstract reset(): void;

  abstract resetTrackingData(): void;

  abstract identifyUser(email: string): void;
}
